import dynamic from 'next/dynamic';

const DynamicNewsletterForm = dynamic(() => import('../forms/newsletter-form'));

export const NewsletterSlice = () => <DynamicNewsletterForm />;
